import { AccessBadge } from "~/pages/manifold-nextgen/components/AccessBadge";
import { ProjectAccessLevel } from "~/services/projects";

export const ACCESS_LEVEL_LABEL: Record<ProjectAccessLevel, string> = {
  [ProjectAccessLevel.OWNER]: "Owner",
  [ProjectAccessLevel.USER]: "User",
};

interface ProjectAccessBadgeProps {
  accessLevel: ProjectAccessLevel | null;
}

export function ProjectAccessBadge({ accessLevel }: ProjectAccessBadgeProps) {
  return <AccessBadge label={accessLevel ? ACCESS_LEVEL_LABEL[accessLevel] : null} />;
}
